import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

import {
  fetchFindSearchCatalogItems,
  TFindSearchCatalogItemsResponse,
} from '../../repositories/geo/v1/find-search-catalog-items';
import { ISearchCatalogItemModel } from '../../repositories/geo/entities/SearchCatalog/SearchCatalogItemModel';

interface IParams {
  text: string;
  httpApi: IHttpApi;
  logger: ILogger;
}

export async function resolveRegionSearchCities({
  text,
  httpApi,
  logger,
}: IParams): Promise<ISearchCatalogItemModel[]> {
  try {
    const result: TFindSearchCatalogItemsResponse = await fetchFindSearchCatalogItems({
      httpApi,
      parameters: { text },
    });

    return result.response.items ?? [];
  } catch (error) {
    logger.error(error);

    return [];
  }
}
